import moment, {type Moment} from 'moment-tz';

export const getElapsedTime = (timestamp: string): string =>
  moment.min([moment(timestamp), moment()]).fromNow();

export const getRemainingTime = (
  timestamp: string | Moment,
  isWithoutSuffix: boolean
): string => moment.max([moment(timestamp), moment()]).fromNow(isWithoutSuffix);
